module.exports = __webpack_public_path__ + "img/Loading_xh_7.70dd4839.png";